// extracted by mini-css-extract-plugin
export default {"wrapper":"Prediction_wrapper__9TrXm","label":"Prediction_label__fu+dM"};